import { useReducer } from 'react';

export default function ur(defaultState){

  // eslint-disable-next-line
  return useReducer(
    (state,props) => ({...state,...props}),
    defaultState
  )
}
